import React from 'react';
const RolesConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/sessions-mau',
			component: React.lazy(() => import('./Index'))
		}
	]
};

export default RolesConfig;
